import { Injectable } from '@angular/core';
import { GqlServiceV2 } from '../../content/service/gql.service-v2';
import { InboxSharingCreateInput } from '@libs/types/src/inbox/input-type/inbox-sharing.create-input';
import { InboxSharingUpdateInput } from '@libs/types/src/inbox/input-type/inbox-sharing.update-input';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';

@Injectable({ providedIn: 'root' })
export class InboxToUserGqlService extends GqlServiceV2 {

    createUserSharing(input: InboxSharingCreateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxSharingCreateInput!) {
                inboxToUser {
                    create(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    updateUserSharing(input: InboxSharingUpdateInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: InboxSharingUpdateInput!) {
                inboxToUser {
                    update(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }

    deleteUserSharing(input: IdInput): Promise<OkObject> {
        return this.mutate(`
            mutation($input: IdInput!) {
                inboxToUser {
                    delete(input: $input) {
                        ok
                    }
                }
            }`,
            { input },
        );
    }
}
